var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 5V3.333H4.166V1.667H12.5V5h.833a.833.833 0 01.833.833v1.834l4.345-3.042a.417.417 0 01.655.342v10.066a.416.416 0 01-.655.342l-4.345-3.042v3.5a.834.834 0 01-.833.834H1.666a.833.833 0 01-.833-.834v-10A.833.833 0 011.666 5h9.167zM4.166 8.333V10h1.667V8.333H4.166z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/camera.svg";
export { SvgCamera as ReactComponent };